import * as React from 'react';

const NewWindow = ({ className }) => {
    return (<>
        <svg viewBox="0 0 16 16" className={`docs-icon ${className || ''}`} xmlns="http://www.w3.org/2000/svg">
            <path d="M15 8V15H1V1H8V2H2V14H14V8H15ZM11.7781 2.77813L10 1H15V6L13.2063 4.20625L8.41563 9L7 7.58437L11.7937 2.79375L11.7781 2.77813Z" />
        </svg>
    </>)
}

export default NewWindow;